<template>
  <div :class="absoluteHeader ? 'absolute' : ''" id="header">
    <div class="header-logo">
      <Logo width="115%" />
    </div>
    <div class="header-content">
      <div class="header-menu">
        <ul class="menu" v-if="menus.header">
          <li v-for="(menuItem, i) in menus.header.items" :key="i">
            <div v-if="menuItem.component === 'menuGroupItem'" class="submenu">
              <a class="menu-item" @click.prevent="getStoryblokLink(menuItem.link, false)" 
                :style="getCssVarsMenuItem(menuItem)"
                :href="setHref(menuItem.link)">
                <span v-html="menuItem.title"></span>
                <fai class="icon" icon="caret-down"></fai>
              </a>
              <!--<span class="menu-item" v-html="menuItem.title"></span>-->
              <ul>
                <li v-for="menuItem in menuItem.items" :key="menuItem.uid">
                  <a class="menu-item" @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank, menuItem.anchor)"
                    :href="menuItem.cached_url" v-html="menuItem.title"></a>
                </li>
              </ul>
            </div>
            <a class="menu-item" v-else
              :style="getCssVarsMenuItem(menuItem)"
              @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank, menuItem.anchor)"
              :href="menuItem.cached_url" v-html="menuItem.title"></a>
          </li>
        </ul>
        <switch-lang></switch-lang>
      </div>

      <checkout-btn></checkout-btn>
      <div class="flex items-center ml-4 text-white gap-4">
        <osv-account-icon drop-down-position="is-right" />
        <sosv-basket />
      </div>

    </div>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  data() {
    return {
      toolbarClass: "top",
    };
  },
  computed: {
    menus() {
      return this.$store.getters.menus;
    },
    absoluteHeader() {
      return this.$store.getters.absoluteHeader;
    },
  },
  methods: {
    getCssVarsMenuItem: function(menuItem) {
      let cssVars = []

      if(menuItem.text_color && menuItem.text_color.color !== '#f40000') {
        cssVars.push(`--color: ${menuItem.text_color.color};`)
      }
      if(menuItem.background_color && menuItem.background_color.color !== '#f40000') {
        cssVars.push(`--bg-color: ${menuItem.background_color.color};`)
      }
      if(menuItem.hover_background_color && menuItem.hover_background_color.color !== '#f40000') {
        cssVars.push(`--hover-bg-color: ${menuItem.hover_background_color.color};`)
      }

      return cssVars.join(' ')
    }
  }
};
</script>

<style lang="scss">
$logoWidth: 170;
#header {
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $primary;
  box-shadow: 0px 2px 20px 3px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 3333;
  /*&.absolute {
    position: absolute;
    z-index: 3333;
    left: 0;
    right: 0;
    top: 0px;
  }*/
  .header-logo {
    width: #{$logoWidth}px;
    margin: 0;
    position: absolute;
    left: 50px;
    z-index: 3;
    top: 20px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .header-content {
    display: inline-flex;
    width: $content-width;
    max-width: $max-width;
    margin: auto;
    position: relative;
    z-index: 2;
    border-radius: 6px;
  }
}
.header-menu {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  height: 120px;
  .menu-item {
    padding: 20px 15px;
    display: block;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    font-weight: bold;
    font-size: $sizeItemMenu;
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 0px;
    height: 100%;
    display: flex;
    align-items: center;
    .icon {
      margin-left: 10px;
    }
    span {
      font-size: $sizeItemMenu;
    }
  }
  > ul {
    display: flex;
    align-items: center;
    height: 100%;
    > li {
      flex: 1;
      height: 100%;
      .menu-item {
          background-color: var(--bg-color, $primary);
          color: var(--color, #fff);
      }
      &:hover {
        .menu-item {
          background-color: var(--hover-bg-color, $primary-D);
        }
      }
      .submenu {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        > ul {
          height: 0;
          overflow: hidden;
          opacity: 0;
          //transition: opacity 0.3s;
          position: absolute;
          top: 100%;
          width: 250px;
          left: 0;
          min-width: 100%;
          background-color: $primary;
          > li {
            .menu-item {
              text-transform: inherit;
              &:hover {
                background-color: $primary-D2;
              }
            }
          }
        }
        &:hover {
          > ul {
            height: auto;
            opacity: 1;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1550px) {
  #header {
    justify-content: flex-end;
    .header-logo {
      width: 120px;
      left: 20px;
      top: 29px;
    }
  }
  .header-menu .menu-item {
    font-size:15px;
    padding:20px 12px;
  }
}
</style>
